import { render, staticRenderFns } from "./TenantAccessManagement.vue?vue&type=template&id=0b41d601&scoped=true&"
import script from "./TenantAccessManagement.vue?vue&type=script&lang=js&"
export * from "./TenantAccessManagement.vue?vue&type=script&lang=js&"
import style0 from "./TenantAccessManagement.vue?vue&type=style&index=0&id=0b41d601&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b41d601",
  null
  
)

export default component.exports